/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Coluser2Inputs */

const zh_adminsubs_coluser2 = /** @type {(inputs: Adminsubs_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户`)
};

const en_adminsubs_coluser2 = /** @type {(inputs: Adminsubs_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const es_adminsubs_coluser2 = /** @type {(inputs: Adminsubs_Coluser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Adminsubs_Coluser2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_coluser2 = /** @type {((inputs?: Adminsubs_Coluser2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Coluser2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_coluser2(inputs)
	if (locale === "en") return en_adminsubs_coluser2(inputs)
	return es_adminsubs_coluser2(inputs)
});
export { adminsubs_coluser2 as "adminSubs_colUser" }